/* eslint-disable react/require-default-props */
import React from 'react';
import { Row } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import colors from '../../constants/Colors';

import { safeExtractFromObject } from '../../helpers/helpers';

function ProfileCircle({
  radius: avatarRadius = 17,
  initials = '',
  style,
  className,
  id,
  fontSize = avatarRadius * 0.85,
  accentColor,
  size = 40,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const useRedesign = !!settings?.uxRedesignPt1;
  const fallbackColor = useRedesign ? colors.ONTRACCR_GRAY : colors.REDESIGN_AVATAR_FONT_COLOR;
  const fontColor = accentColor ?? fallbackColor;
  let fullClassName = className;
  let baseStyle = {
    width: avatarRadius * 2,
    height: avatarRadius * 2,
    borderRadius: avatarRadius,
    ...style,
  };
  if (useRedesign) {
    fullClassName = `${fullClassName} ontraccr-profile-redesign`;
  } else {
    baseStyle = {
      ...baseStyle,
      backgroundColor: colors.MAIN_BACKGROUND,
      border: 'solid',
      borderWidth: 0.2,
      borderColor: accentColor,
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };
  }
  return (
    <div
      style={{
        ...baseStyle,
        ...style,
      }}
      className={fullClassName}
      id={id}
    >
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{
          pointerEvents: 'none',
          color: fontColor,
          fontFamily: useRedesign ? 'open-sans, sans-serif' : 'roboto-regular',
          fontSize,
          userSelect: 'none',
        }}
      >
        {initials.toUpperCase()}
      </Row>
    </div>
  );
}

ProfileCircle.propTypes = {
  radius: PropTypes.number,
  initials: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  id: PropTypes.string,
  fontSize: PropTypes.number,
  accentColor: PropTypes.string,
  size: PropTypes.number,
};

export default ProfileCircle;
